import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Configuración de Firebase
// IMPORTANTE: Estos valores deben configurarse en tu proyecto de Firebase
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCr8pbvcZ1ouR1KrZnxrdt7Sa6n2_la0HE",
  authDomain: "laclobrand-ea344.firebaseapp.com",
  projectId: "laclobrand-ea344",
  storageBucket: "laclobrand-ea344.firebasestorage.app",
  messagingSenderId: "74984999154",
  appId: "1:74984999154:web:15bff5da868cf3b674e86b",
  measurementId: "G-651LEWL34P"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
